import { render, staticRenderFns } from "./ListFactureClientsReg.vue?vue&type=template&id=35d0e707&scoped=true&"
import script from "./ListFactureClientsReg.vue?vue&type=script&lang=js&"
export * from "./ListFactureClientsReg.vue?vue&type=script&lang=js&"
import style0 from "./ListFactureClientsReg.vue?vue&type=style&index=0&id=35d0e707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d0e707",
  null
  
)

export default component.exports